<template>
  <svg
    v-if="percent < 100"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    style="transform: rotate(-90deg)"
  >
    <circle
      cx="8.99971"
      cy="8.99971"
      r="7.49971"
      :stroke="percent <= 0 ? '#EEEFF0' : '#DBDBDB'"
      stroke-width="3"
      stroke-dasharray="565.48"
      stroke-dashoffset="0"
      :fill="percent <= 0 ? '#EEEFF0' : undefined"
    />
    <circle
      cx="8.99971"
      cy="8.99971"
      r="7.49971"
      stroke="#48A0FF"
      stroke-width="3"
      stroke-dasharray="565.48"
      stroke-dashoffset="0"
      :style="`stroke-dashoffset: ${offset}`"
    />
  </svg>
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <circle cx="9" cy="9" r="9" fill="#01893D" />
    <path
      d="M7.4301 10.931L5.62503 9.20711L4.5 10.2949L7.43257 13.0148L13.5 6.48734L12.3646 5.39941L7.4301 10.931Z"
      fill="white"
    />
  </svg>
</template>

<script setup lang="ts">
import { PropType, Ref, onMounted, ref, watch } from "vue";

const props = defineProps({
  percent: {
    type: Number as PropType<number>,
    default: 99,
  },
});

const offset: Ref = ref(0);

watch(
  () => props.percent,
  (val) => {
    onChange(val);
  },
);

onMounted(() => {
  onChange(props.percent);
});
const onChange = (val) => {
  let inpVal: number = !val ? 0 : val;
  inpVal = Math.max(0, Math.min(100, inpVal));
  offset.value = 519 + (47 / 100) * (100 - inpVal);
};
</script>

<style scoped>
#svg circle {
  stroke-dashoffset: 0;
  transition: stroke-dashoffset 1s linear;
  stroke: #dbdbdb;
  stroke-width: 1em;
}
#svg #bar {
  stroke: #48a0ff;
}
</style>
